export const enumToI18nObject = <Hash extends Record<string, string>>(
  object: Hash
): Hash =>
  Object.values(object).reduce(
    (obj, key) => ({...obj, [key]: key}),
    {}
  ) as Hash;
